
import { defineComponent, ref } from "vue";
import GraphFilterComponent from "@/components/graphs/graphClientFilter.component.vue";
import { Parameter } from "@/types/parameter.type";
import { ClientData } from "@/types/clientData.type";
import GraphClientChartComponent from "@/components/graphs/graphClientChart.component.vue";
import { GraphClientFilter } from "@/types/graphClient";
import { getSamplingPointById } from "@/service/samplingpoint.service";
import { samPointOnlyParametersClient } from "@/service/samplingpoint.service";

export default defineComponent({
  components: {
    GraphFilterComponent,
    GraphClientChartComponent,
  },
  data() {
    return {
      parameter: [] as Parameter[],
      parameterClient: [] as ClientData[],
      rowPerPage: 10 as number,
      totalRows: 0 as number | undefined,
      currentPage: 0 as number,
      loading: false,
      loadingUpload: false,
      visualizeGraph: false,
      uploadType: ref("automatic"),
      graphClientFilter: {} as GraphClientFilter,
      changeFilter: false as boolean,
      graphKey: 0 as number, //
      samplingPointId: this.$route.query.samplingPointId, //Si se viene de importData
      parameterId: this.$route.query.parameterId, //Si se viene de importData
    };
  },
  methods: {
    async postData() {
      this.loading = false;
      await (this.$refs["filter"] as InstanceType<typeof GraphFilterComponent>)
        .valdidate()
        .then(() => {
          this.loading = true;
        });
      let changeFilter = await (
        this.$refs["filter"] as InstanceType<typeof GraphFilterComponent>
      ).checkFilterChange();
      await (this.$refs["filter"] as InstanceType<typeof GraphFilterComponent>)
        .postDataFilter()
        .then(async (data: any) => {
          if (data) {
            if (changeFilter) {
              //La variable incrementa la key del componete de la grafica
              //Por que al modificar la key Vue cuenta como si es un componete nuevo y recarga el componete
              this.graphKey++;
            }
            this.graphClientFilter = data;
            //Emitir evento con los datos
            this.$emit("graphData", this.graphClientFilter);
            this.visualizeGraph = true;
          }
        });
    },
    async handleGraphData(data: any) {
      this.graphClientFilter = data;
      if (this.samplingPointId && this.parameterId) {
        //Si se viene de importar datos, autocompleta el parametro cliente y samplingpoint

        const parameters_client = await samPointOnlyParametersClient(Number(this.samplingPointId));

        const parameter = parameters_client.find(
          (parameter) => parameter.id === Number(this.parameterId)
        );
        this.graphClientFilter.parameterClient = parameter;

        const samplingPoint = await getSamplingPointById(Number(this.samplingPointId));
        this.graphClientFilter.samplingPoint = samplingPoint;
      }
    },
    detectedChange() {
      this.changeFilter = true;
    },
  },
});
